export { default } from './lozenge';
export type { ThemeAppearance, LozengeProps } from './lozenge';
export { default as LozengeDropdownTrigger } from './new/lozenge-dropdown-trigger';
export type {
	NewLozengeProps,
	LozengeColor as NewLozengeColor,
	LozengeDropdownTriggerProps,
	LozengeSpacing,
	SemanticColor,
	AccentColor,
} from './new/types';
